import $ from 'jquery';

$(() => {
  if ($('.hero-slider').length) {
    $('.hero-slider .slider').slick({
      appendDots: '.hero-slider-nav .wrapper',
      dots: true,
      infinite: false,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 8000,
      touchThreshold: 25,
    });

    $('.hero-slider .slider').on('afterChange', (e, s, i) => {
      if ((s.slideCount - 1) === i) {
        setTimeout(() => {
          $('.hero-slider .slider').slick('slickGoTo', 0);
        }, 8000);
      }
    });
  }

  if ($('.publications-slider').length) {
    $('.publications-slider .slider').slick({
      appendDots: '.publications-slider-nav .wrapper',
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      speed: 1000,
      infinite: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});



/** WEBPACK FOOTER **
 ** ./src/js/carousels.js
 **/